import { ErrorMessage } from '@hookform/error-message';
import { FormControl, FormLabel, InputLabel, ListSubheader, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

/** Renders dropdown options with non-selectable group headings. */
export const SelectRhf = ({ option, name, label, disabled = false, defaultValue = '', selectRhfStyle = {}, showLabel = false }) => {
    const {
        formState: { errors },
        control,
    } = useFormContext();
    return (
        <FormControl variant="standard" size="small">
            {/* <InputLabel disabled={disabled}>{label}</InputLabel> */}
            {showLabel && <InputLabel disabled={disabled}>{label}</InputLabel>}
            <Controller
                rules={{ required: true }}
                control={control}
                name={name}
                render={({ field: { onChange, value } }) => (
                    <Select
                        id={name}
                        className={value === '' || value === null || value === undefined || value === '0' || value === 'select' ? 'select-empty-value' : ''}
                        onChange={onChange}
                        value={value}
                        style={{ width: '100%', minWidth: 100, ...selectRhfStyle }}
                        disabled={disabled}
                        variant="standard"
                    >
                        {option.map((v, i) =>
                            v.isGroup ? (
                                <ListSubheader key={`${name}-${i}`} disableSticky>
                                    {v.label}
                                </ListSubheader>
                            ) : (
                                <MenuItem key={`${name}-${i}`} value={v.value}>
                                    {v.label}
                                </MenuItem>
                            )
                        )}
                    </Select>
                )}
                defaultValue={defaultValue}
            />
            <div style={{ marginLeft: 8 }}>
                <ErrorMessage
                    errors={errors}
                    name={name}
                    render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                />
            </div>
        </FormControl>
    );
};
